import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface IntervalSelectProps {
  value: string;
  onChange: (value: string) => void;
}

export const IntervalSelect = ({ value, onChange }: IntervalSelectProps) => (
  <div className="space-y-2">
    <label className="text-sm font-medium">Intervalo de Repetição</label>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger>
        <SelectValue placeholder="Selecione o intervalo" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="30days">30 dias</SelectItem>
        <SelectItem value="60days">60 dias</SelectItem>
        <SelectItem value="90days">90 dias</SelectItem>
      </SelectContent>
    </Select>
  </div>
);